<div id="earlypayout-activation" class="earlypayout-activation-modal">
    <div class="epa-content">
        <div class="title">
            <div class="title-text">{{ sitecore.earlyPayoutV2.Title }}</div>
        </div>

        <div class="conditions-list">
            <div class="check"><i class="theme-check"></i></div>
            <div class="condition">{{ sitecore.earlyPayoutV2.ActivationCondition1 }}</div>
        </div>
        <div class="conditions-list">
            <div class="check"><i class="theme-check"></i></div>
            <div class="condition">{{ sitecore.earlyPayoutV2.ActivationCondition2 }}</div>
        </div>
        <div class="conditions-list">
            <div class="check"><i class="theme-check"></i></div>
            <div class="condition">{{ sitecore.earlyPayoutV2.ActivationCondition3 }}</div>
        </div>
    </div>
    <div class="epa-buttons">
        <div class="info" [innerHTML]="activationInformation"></div>

        <div class="accept-tac">
            <button ds-button kind="secondary" variant="filled" size="large" [disabled]="false" (click)="acceptTac()">
                {{ sitecore.earlyPayoutV2.ActivationButton }}
            </button>
        </div>
    </div>
</div>
